import asyncComponent from '../../components/AsyncComponent';

const LetterView = asyncComponent(() => import('../../containers/Letter/View'));

export default LetterView;
